import { on, off, addClass, removeClass } from '@/utils'
const temp = []
export const inputBorder = {
  inserted (el, binding) {
    const { className } = binding.value
    const elm = el.querySelector('input')
    const focusEvent = e => addClass(el, className)
    const blurEvent = e => removeClass(el, className)
    on(elm, 'focus', focusEvent)
    on(elm, 'blur', blurEvent)
    temp.push({
      el,
      elm,
      events: {
        focusEvent,
        blurEvent
      }
    })
  },
  unbind (el) {
    const index = temp.findIndex(item => item.el === el)
    if (index > -1) {
      const [item] = temp.splice(index, 1)
      const { elm, events } = item
      off(elm, 'focus', events.focusEvent)
      off(elm, 'blur', events.blurEvent)
    }
  }
}
